import { render, staticRenderFns } from "./Antecedentes.vue?vue&type=template&id=69f16e40"
import script from "./Antecedentes.vue?vue&type=script&lang=js"
export * from "./Antecedentes.vue?vue&type=script&lang=js"
import style0 from "./Antecedentes.vue?vue&type=style&index=0&id=69f16e40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports